import { render, staticRenderFns } from "./Detailspage.vue?vue&type=template&id=6a49f910&scoped=true"
import script from "./Detailspage.vue?vue&type=script&lang=js"
export * from "./Detailspage.vue?vue&type=script&lang=js"
import style0 from "./Detailspage.vue?vue&type=style&index=0&id=6a49f910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a49f910",
  null
  
)

export default component.exports
import {QSkeleton,QCarousel,QCarouselSlide,QBtn,QSpinnerDots,QDialog,QCard,QCardSection,QCardActions,QIcon,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton,QCarousel,QCarouselSlide,QBtn,QSpinnerDots,QDialog,QCard,QCardSection,QCardActions,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
